export default __webpack_public_path__ + "img/embed-link.a4627766.svg";